import React from 'react';

import { Stack, BodyText } from '../../../../../ui';
// eslint-disable-next-line
import FireStarsLightGrey from "../../../../../ui/Icons/FireStarsLightGrey";

import Title from '../../Title';
import ProgressBar from '../../ProgressBar';

const PreEarning: React.FC = () => (
  <Stack justifyContent="center" alignItems="center">
    <FireStarsLightGrey />
    <Title modeText="EARN A" />
    <BodyText appearance="small" textAlign="center">
      Search Boost pushes your business to the top of client searches in your
      area. Set up your services, photos, and availability to unlock!
    </BodyText>
    <ProgressBar disabled />
  </Stack>
);

export default PreEarning;
